import { render } from "./ReferenceStructureLegend.vue?vue&type=template&id=2ceeb0ba&scoped=true"
import script from "./ReferenceStructureLegend.vue?vue&type=script&lang=js"
export * from "./ReferenceStructureLegend.vue?vue&type=script&lang=js"

import "./ReferenceStructureLegend.vue?vue&type=style&index=0&id=2ceeb0ba&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceeb0ba"]])

export default __exports__